const ByzantineEra = {
  id: '7',
  name: 'Byzantine Era'
};

export default ByzantineEra;
